import { render, staticRenderFns } from "./BsInputGroup.vue?vue&type=template&id=5a5fc24d"
import script from "./BsInputGroup.vue?vue&type=script&lang=ts"
export * from "./BsInputGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports